import { authenticationService } from "../AuthinticationService";
import restApi from "./RestApi";

const getCurrentUser = () => {
  return authenticationService.currentUserValue;
};

const AdminApi = {
  getAllSites: async () => {
    return await restApi.get(
      `admin/${getCurrentUser().profile["UserID"]}/sites/getAll`
    );
  },

  addSite: async (entry) => {
    return await restApi.post(
      `admin/${getCurrentUser().profile["UserID"]}/sites/add`,
      entry
    );
  },

  updateSite: async (siteIndex, payload) => {
    const userId = getCurrentUser().profile["UserID"];
    return await restApi.post(`admin/${userId}/sites/${siteIndex}`, payload);
  },

  editUser: async (entry) => {
    return await restApi.post(
      `admin/${getCurrentUser().profile["UserID"]}/users/${entry["UserID"]}`,
      entry
    );
  },

  createUser: async (entry) => {
    
    return await restApi.post(
      `admin/${getCurrentUser().profile["UserID"]}/users/createUser`,
      entry
    );
  },

  getAllUsers: async (filtersArr) => {
    return await restApi.post(
      `admin/${getCurrentUser().profile["UserID"]}/users/getAll`,
      filtersArr
    );
  },

  getAllDashboardData: async (siteId = "all", range = 30) => {
    return await restApi.post(
      `admin/${
        getCurrentUser().profile["UserID"]
      }/dashboard/getAllDashboardData`,
      { siteId, range }
    );
  },
};
export default AdminApi;
